<template>
  <div>
    <LeafletMapLoader :msg="mapMsg" :display="displayLoader"></LeafletMapLoader>
    <div :id="mapId" class="mymap map"></div>
    <v-dialog
      v-model="toggleFilter"
      persistent
      max-width="800px"
      style="z-index: 10000"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Case Assignment Map View Settings</span>
        </v-card-title>
        <v-card-text>
          <form class="leaflet-control-layers-list">
            <v-container fluid>
              <v-row justify="start">
                <v-col class="task-type-border">
                  <v-checkbox
                    class="standard-controls legendItem"
                    v-model="isShowRegular"
                    @change="onToggleScreensChanged($event)"
                  >
                    <template v-slot:label> Show Regular Tasks </template>
                  </v-checkbox>
                </v-col>
                <v-col class="task-type-border">
                  <v-checkbox
                    class="standard-controls legendItem"
                    v-model="isShowScreener"
                    @change="onToggleScreensChanged($event)"
                  >
                    <template v-slot:label> Show Screener Tasks </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col class="task-type-border">
                  <v-checkbox
                    class="standard-controls legendItem"
                    v-model="mapViewModel.isUnassignedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isUnassignedDisplayed, 1)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/wgmm_ico_map_ace_suspect_address.svg"
                        style="height: 45px; width: 45px"
                      />Unassigned
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isNotReviewedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isNotReviewedDisplayed, 2)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/wgmm_ico_map_ace_found_address.svg"
                        style="height: 45px; width: 45px"
                      />Not Reviewed
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isConfirmedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isConfirmedDisplayed, 3)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/wgmm_ico_map_ace_valid_address.svg"
                        style="height: 45px; width: 45px"
                      />Confirmed
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isAssignedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isAssignedDisplayed, 4)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/case_assigned_normal.svg"
                        style="height: 45px; width: 45px"
                      />Assigned
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isUnassignedHighPriorityDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isUnassignedHighPriorityDisplayed, 5)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/wgmm_ico_map_ace_added_suspect.svg"
                        style="height: 45px; width: 45px"
                      />Unassigned - High Priority
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isNotReviewedHighPriorityDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isNotReviewedHighPriorityDisplayed, 6)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/wgmm_ico_map_ace_found_address_added.png"
                        style="height: 45px; width: 45px"
                      />Not Reviewed - High Priority
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isConfirmedHighPriorityDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isConfirmedHighPriorityDisplayed, 7)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/wgmm_ico_map_ace_added_valid.svg"
                        style="height: 45px; width: 45px"
                      />Confirmed - High Priority
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isAssignedHighPriorityDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isAssignedHighPriorityDisplayed, 8)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/case_assigned_priority.svg"
                        style="height: 45px; width: 45px"
                      />Assigned - High Priority
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col class="task-type-border">
                  <v-checkbox
                    class="standard-controls legendItem"
                    v-model="mapViewModel.isScreenerUnassignedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isScreenerUnassignedDisplayed, 9)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_unassigned_normal.svg"
                        style="height: 45px; width: 45px"
                      />Screen Unassigned
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isScreenerNotReviewedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isScreenerNotReviewedDisplayed, 10)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_notreviewed_normal.svg"
                        style="height: 45px; width: 45px"
                      />Screen Not Reviewed
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isScreenerConfirmedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isScreenerConfirmedDisplayed, 11)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_confirmed_normal.svg"
                        style="height: 45px; width: 45px"
                      />Screen Confirmed
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="mapViewModel.isScreenerAssignedDisplayed"
                    @change="onMapSettingsChanged(mapViewModel.isScreenerAssignedDisplayed, 12)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_assigned_normal.svg"
                        style="height: 45px; width: 45px"
                      />Screen Assigned
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="
                      mapViewModel.isScreenerUnassignedHighPriorityDisplayed
                    "
                    @change="onMapSettingsChanged(mapViewModel.isScreenerUnassignedHighPriorityDisplayed, 13)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_unassigned_priority.svg"
                        style="height: 45px; width: 45px"
                      />Screen Unassigned - High Priority
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="
                      mapViewModel.isScreenerNotReviewedHighPriorityDisplayed
                    "
                    @change="onMapSettingsChanged(mapViewModel.isScreenerNotReviewedHighPriorityDisplayed, 14)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_notreviewed_priority.svg"
                        style="height: 45px; width: 45px"
                      />Screen Not Reviewed - High Priority
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="
                      mapViewModel.isScreenerConfirmedHighPriorityDisplayed
                    "
                    @change="onMapSettingsChanged(mapViewModel.isScreenerConfirmedHighPriorityDisplayed, 15)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_confirmed_priority.svg"
                        style="height: 45px; width: 45px"
                      />Screen Confirmed - High Priority
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    class="standard-controls"
                    v-model="
                      mapViewModel.isScreenerAssignedHighPriorityDisplayed
                    "
                    @change="onMapSettingsChanged(mapViewModel.isScreenerAssignedHighPriorityDisplayed, 16)"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/screener_assigned_priority.svg"
                        style="height: 45px; width: 45px"
                      />Screen Assigned - High Priority
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
            <v-checkbox
              class="standard-controls"
              v-model="mapViewModel.isStaffDisplayed"
              @change="onMapSettingsChanged(mapViewModel.isStaffDisplayed, 0)"
            >
              <template v-slot:label>
                <img
                  src="../assets/wgmm_ico_map_interviewer_home.svg"
                  style="height: 45px; width: 45px"
                />Staff
              </template>
            </v-checkbox>
          <v-spacer></v-spacer>
          <v-btn
            color="rgb(21 72 124)"
            dark
            class="ma-2"
            @click="toggleFilter = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as L from "leaflet";
import "leaflet-polylinedecorator";
import FreeDraw, { CREATE, EDIT, DELETE, NONE, ALL } from "leaflet-freedraw";
import { MAP_CONSTANTS } from "@/common/map.constants.js";
import { TASK_CONSTANTS } from "@/common/task.constants.js";
import { mapMarkerService } from "../services/map.marker.service";
import { STORE_CONSTANTS } from "@/common/store.constants";

export default {
  name: "AssignmentLeafletMap",
  props: {
    mapId: String,
    isFullScreen: Boolean,
    staffName: String,
    study: String,
    mapMsg: String,
    displayLoader: Boolean,
  },
  data: () => ({
    STORE_CONSTANTS,
    myMap: null,
    region: null,
    toggleFilter: false,
    mapViewModel: {
      isStaffDisplayed: true,
      isUnassignedDisplayed: true,
      isUnassignedHighPriorityDisplayed: true,
      isNotReviewedDisplayed: true,
      isNotReviewedHighPriorityDisplayed: true,
      isConfirmedDisplayed: true,
      isConfirmedHighPriorityDisplayed: true,
      isAssignedDisplayed: true,
      isAssignedHighPriorityDisplayed: true,
      isScreenerUnassignedDisplayed: true,
      isScreenerUnassignedHighPriorityDisplayed: true,
      isScreenerNotReviewedDisplayed: true,
      isScreenerNotReviewedHighPriorityDisplayed: true,
      isScreenerConfirmedDisplayed: true,
      isScreenerConfirmedHighPriorityDisplayed: true,
      isScreenerAssignedDisplayed: true,
      isScreenerAssignedHighPriorityDisplayed: true,
    },
    // Markers placed on\displayed on the map
    mapFeatureMarkers: {
      unknown: [],
      staff: [],
      assignedArea: [],
      unassigned: [],
      unassignedHighPriority: [],
      notReviewed: [],
      notReviewedHighPriority: [],
      confirmed: [],
      confirmedHighPriority: [],
      assigned: [],
      assignedHighPriority: [],
      screenerUnassigned: [],
      screenerUnassignedHighPriority: [],
      screenerNotReviewed: [],
      screenerNotReviewedHighPriority: [],
      screenerConfirmed: [],
      screenerConfirmedHighPriority: [],
      screenerAssigned: [],
      screenerAssignedHighPriority: [],
      allAssignedTasks: {}
    },
    isDrawing: false,
    selectedRegionCases: null,
    selectedStaffId: "",
    selectedDwellingId: "",
    allFeatures: null,
    tables: {},
    allStaffData: null,
    hiddenMarkersForStaff: [],
    bounds: null,
    // markers selection display
    isShowRegular: true,
    isShowScreener: true,
    ASSIGNMENT_MARKER_TYPES: [
      'unknown',
      'staff',
      'assignedArea',
      'unassigned',
      'unassignedHighPriority',
      'notReviewed',
      'notReviewedHighPriority',
      'confirmed',
      'confirmedHighPriority',
      'assigned',
      'assignedHighPriority',
      'screenerUnassigned',
      'screenerUnassignedHighPriority',
      'screenerNotReviewed',
      'screenerNotReviewedHighPriority',
      'screenerConfirmed',
      'screenerConfirmedHighPriority',
      'screenerAssigned',
      'screenerAssignedHighPriority'
    ],
    TASK_LAYER_NAMES: [
      'unassigned',
      'unassignedHighPriority',
      'notReviewed',
      'notReviewedHighPriority',
      'confirmed',
      'confirmedHighPriority',
      'assigned',
      'assignedHighPriority',
      'screenerUnassigned',
      'screenerUnassignedHighPriority',
      'screenerNotReviewed',
      'screenerNotReviewedHighPriority',
      'screenerConfirmed',
      'screenerConfirmedHighPriority',
      'screenerAssigned',
      'screenerAssignedHighPriority'
    ],
    ASSIGNED_TASK_LAYER_NAMES: [
      'notReviewed',
      'notReviewedHighPriority',
      'confirmed',
      'confirmedHighPriority',
      'assigned',
      'assignedHighPriority',
      'screenerNotReviewed',
      'screenerNotReviewedHighPriority',
      'screenerConfirmed',
      'screenerConfirmedHighPriority',
      'screenerAssigned',
      'screenerAssignedHighPriority'
    ],
    layerPopup: null,
    isLoadingObject: {
      staffId: false,
      dwellingId: false,
      geoJson: false,
      regionTable: false
    },
    mutationInfo: {
      mutationName: "",
      mutatedData: null
    },
    mapMutationInfo:  {
      mutationName: "",
      mutatedData: null
    },
  }),
  computed: {
    regionTable: function () {
      return this.tables[this.region];
    },
  },
  watch: {
    mapMutationInfo: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.onHandleUpdateGeoJson(newValue.mutatedData);
      }
    },
    /**
     * Watcher for 'mutationInfo' which is set inside the store's mutation listener
     *
     * @param {*} newValue
     * @param {*} oldValue
     */
    mutationInfo: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        //setDwellingId
        if(newValue.mutationName === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_DWELLING_ID) {
          this.onHandleUpdatedDwellingId(newValue.mutatedData);
        }

        //setGeoJson
        if(newValue.mutationName === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_GEO_JSON) {
          this.onHandleUpdateGeoJson(newValue.mutatedData);
        }

        //setStaffId
        if(newValue.mutationName === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_STAFF_ID) {
          this.onHandleUpdatedStaffId(newValue.mutatedData);
        }

        //setTablesJson
        if(newValue.mutationName === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_TABLE_JSON) {
          this.onHandleUpdatingTableJson(newValue.mutatedData);
        }
      }
    },
  },
  created() {
    const me = this; // set to reference this within store's mutation listener scope

    // Subscribe to listen to mutations to the map store
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      // If someone clicked a case in the upper right table
      // find point on the map and show popup...
      if (mutation.type === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_DWELLING_ID) {
        me.mutationInfo = Object.create({
          mutationName: this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_DWELLING_ID,
          mutatedData: state.assignment.dwellingId
        });
      }

      // Handles adding markers to the map when we switch a region
      if (mutation.type === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_GEO_JSON) {
        me.mapMutationInfo = Object.create({
          mutationName: this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_GEO_JSON,
          mutatedData: state.assignment.geoJson[0].features
        });
      }

      // Handles highlighting the assignedArea when the selected staff is changed
      if (mutation.type === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_STAFF_ID) {
        me.mutationInfo = Object.create({
          mutationName: this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_STAFF_ID,
          mutatedData: state.assignment.staffId
        });
      }

      // Handles calculating region assignment information for staff when we switch a region
      if (mutation.type === this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_TABLE_JSON) {
        me.mutationInfo = Object.create({
          mutationName: this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_TABLE_JSON,
          mutatedData: state.assignment.tableJson
        });
      }
    });
  },
  mounted() {
    this.initMap();
  },
  destroyed() {
    if(this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    /**
     * Updates internal component state data 'allStaffData' & 'tables' based on selected region mutation.
     *
     * @param {*} tables
     */
    onHandleUpdatingTableJson(tables) {
      // If we have not initialized this data yet, do so here
      if(!this.tables) {
        this.tables = {};
      }

      this.allStaffData = null;
      //Iterate the keys in the region table (key -> the region ID)
      for (let key in tables) {
        //Set the region id here
        this.region = key;
        //Add region info here with region Id as key
        this.tables[key] = tables[key];
        this.allStaffData = Object.values(this.tables[this.region].caseLoadMap);
      }
    },
    /**
     * Update the map based on the selected dwelling id mutation
     *
     * @param {*} duid - the currently selected duid
     */
    onHandleUpdatedDwellingId(duid) {
      this.selectedDwellingId = duid;
      //If we have a map and markers, look for point and show popup
      if (this.myMap && this.mapFeatureMarkers) {
        this.onCaseClicked(this.selectedDwellingId);
      }
    },
    /**
     * Update the map based on the selected region mutation
     *
     * @param {*} features - geo JSON feature data (cases & staff homes) for map
     */
    onHandleUpdateGeoJson(features) {
      this.clearMap();
      this.loadMapMarkers(features);
    },
    /**
     * Update the map based on the selected staff id mutation
     *
     * @param {*} staffId  - selected staff identifier
     */
    onHandleUpdatedStaffId(staffId) {
      if (this.selectedStaffId !== staffId) {
        this.selectedStaffId = staffId;

        if (MAP_CONSTANTS.CASE_ASSIGN_GENERIC_STAFF_ID.UNASSIGNED === this.selectedStaffId) {
          this.highlightStaffPolygon(null);
          if (this.bounds) {
            this.myMap.fitBounds(this.bounds, {
              animate: true,
              padding: [5, 5],
            });
          }
        } else {
          if (this.mapFeatureMarkers) {
            this.highlightStaffPolygon(this.selectedStaffId);
          }
        }
      }
    },
    /**
     * Handles creating layers/markers for the features and adding them to the map. Cleans up
     * any existing markers and their helpers, handlers, etc. Sets up some event handlers
     * for the new markers
     *
     * @param {*} features
     */
    loadMapMarkers(features) {
      this.allFeatures = features;
      const sortedFeatures = mapMarkerService.sortAssignmentMarkers(this.allFeatures);

      const me = this;  //reference to this for inside foreach loop...
      this.ASSIGNMENT_MARKER_TYPES.forEach((layerName) => {
        //clean up previous layer markers....
        if(me.mapFeatureMarkers[layerName].off) {
          me.mapFeatureMarkers[layerName].off('click');
          me.mapFeatureMarkers[layerName].off('mouseover');
        }

        //Remove the layer from the map
        me.myMap.removeLayer(me.mapFeatureMarkers[layerName]);
        //Create a new LayerGroup to hold the markers for the layer
        me.mapFeatureMarkers[layerName] = L.layerGroup();

        //If we have features for the layer, add them here
        if(sortedFeatures[layerName]) {
          //Get markers for the layer
          me.mapFeatureMarkers[layerName] = mapMarkerService.getAssignmentMapMarkers(sortedFeatures[layerName]);

          if(layerName === 'staff') {
            me.mapFeatureMarkers[layerName].on("mouseover", (evt) => {
              const src = evt.sourceTarget;
              me.selectedStaffId = src.feature.properties.StaffId;
              const div = document.getElementById("_divStaffId");
              //Checking just in case something has gone terribly wrong....
              if (div) {
                div.innerHTML = `Staff ID: ${me.selectedStaffId}`;
              }
            });

            me.mapFeatureMarkers[layerName].on("click", (evt) => {
              const src = evt.sourceTarget;
              const staffId = src.feature.properties.StaffId,
                staffName = src.feature.properties.StaffName;
              const table = me.tables[me.region].caseLoadMap[staffId];
              const data = {
                staffId: staffId,
                staffName: staffName,
                count: table.caseList.length,
                utilization: me.percent(Number(table.utilization)),
                durationTravel: table.durationTravel,
                durationTask: table.durationTask
              };
              const content = mapMarkerService.getAssignmentStaffPopupContent(data);
              me.layerPopup.setContent(content);
              me.layerPopup.setLatLng(src.getLatLng());
              me.myMap.openPopup(me.layerPopup);
            });
          } else if(me.TASK_LAYER_NAMES.includes(layerName)) {
            me.mapFeatureMarkers[layerName].on("click", me.onHandleTaskOnClick);
          }
        }
        me.mapFeatureMarkers[layerName].addTo(me.myMap);
      });

      // Get all points that will be placed on the map
      me.bounds = L.geoJson(me.allFeatures).getBounds();
      if (me.bounds && Object.keys(me.bounds).length > 0) {
        me.myMap.fitBounds(me.bounds, {
          animate: true,
          padding: [5, 5],
        });
      }
    },
    onHandleTaskOnClick(evt) {
      const src = evt.sourceTarget,
        feature = src.feature;
      let statusWord = feature.properties.Status;
      if (feature.properties.Status === "NOTREVIEWED") {
        statusWord = "Not Reviewed";
      }

      let popupAddress = "";
      // looping through bottom row data to compare DUIDS to find address // this just supplies the address for the entire map
      for (let check of this.allStaffData) {
        if (feature.properties.DUID === check.dwellingId) {
          popupAddress = check.address.streetAddress + " " +
            check.address.placeName + "," +
            check.address.adminAreaCode + " " +
            check.address.postCode;
        }
      }

      const content = mapMarkerService.getAssignmentTaskPopupContent(statusWord, popupAddress, feature.properties);
      this.layerPopup.setContent(content);
      this.layerPopup.setLatLng(src.getLatLng());
      this.myMap.openPopup(this.layerPopup);
    },
    clearMap() {
      this.allFeatures = null;
      this.selectedRegionCases = {};

      if(this.layerPopup) {
        this.myMap.closePopup(this.layerPopup);
      }
    },
    initMap() {
      this.layerPopup = L.popup();
      let normal = L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          maxZoom: 21,
          id: "mapbox/streets-v11",
          tileSize: 512,
          zoomOffset: -1,
        }
      );
      let satellite = L.tileLayer(
        "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
        {
          id: "satellitemap",
          maxZoom: 21,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );
      this.myMap = L.map(this.mapId, {
        drawControl: true,
        center: [29.6097547, -95.27213739999999],
        zoom: 5,
        layers: [satellite, normal],
        preferCanvas: true,
        renderer: L.canvas(),
        zoomAnimation: false
      });

      let baseMaps = {
        Satellite: satellite,
        Normal: normal,
      };
      L.control.layers(baseMaps).addTo(this.myMap);
      L.control
        .scale({
          maxWidth: 240,
          metric: false,
          imperial: true,
          position: "bottomleft",
        })
        .addTo(this.myMap);

      // let polylineMeasure = L.control.polylineMeasure({
      //   position: "topleft",
      //   unit: "landmiles",
      //   showBearings: true,
      //   clearMeasurementsOnStop: true,
      //   showClearControl: true,
      //   showUnitControl: true,
      // });
      // polylineMeasure.addTo(this.myMap);

      const me = this;
      // Add the map markers filter control to the map on the top left
      let filterControl = L.control({ position: "topleft" });
      filterControl.onAdd = function (map) {
        let div = L.DomUtil.create("div");
        // clean up this part
        div.innerHTML = ``;

        div.onclick = function (evt) {
          me.onToggleMapFilter(evt);
        };

        div.setAttribute("class", "map-button mdi mdi-filter-outline tool");

        return div;
      };
      filterControl.addTo(this.myMap); // your map variable

      const freeDraw = new FreeDraw({ mode: NONE });
      freeDraw.on("markers", (event) => {
        if (event.eventType === "create") {
          freeDraw.mode(NONE);
          const bounds = L.latLngBounds(event.latLngs);
          Vue.set(me, "selectedRegionCases", {});

          // me is scoped outside of this event handler
          const regionTable = me.regionTable;
          if (regionTable) {
            const unassignedCaseList = me.unassignedCaseList;
            if (unassignedCaseList && unassignedCaseList.length > 0) {
              me.findPointsInRegionWithTypeCheck(
                unassignedCaseList,
                bounds,
                true
              );
            }
          }

          const THE_MAP_VIEW_MODEL = me.mapViewModel;
          const MAP_MARKERS = me.mapFeatureMarkers;

          if (THE_MAP_VIEW_MODEL.isUnassignedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.unassigned, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isUnassignedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.unassignedHighPriority, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isNotReviewedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.notReviewed, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isNotReviewedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.notReviewedHighPriority, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isConfirmedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.confirmed, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isConfirmedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.confirmedHighPriority, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isAssignedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.assigned, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isAssignedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.assignedHighPriority, bounds);
          }

          // screener stuff
          if (THE_MAP_VIEW_MODEL.isScreenerUnassignedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerUnassigned, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerUnassignedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerUnassignedHighPriority, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerNotReviewedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerNotReviewed, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerNotReviewedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerNotReviewedHighPriority, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerConfirmedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerConfirmed, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerConfirmedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerConfirmedHighPriority, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerAssignedDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerAssigned, bounds);
          }

          if (THE_MAP_VIEW_MODEL.isScreenerAssignedHighPriorityDisplayed) {
            me.findPointsInRegion(MAP_MARKERS.screenerAssignedHighPriority, bounds);
          }
          // end Screener stuff

          // disable drawing
          me.isDrawing = false;
          fnToggleDrawing(me.isDrawing);

          me.openMultiplePopUp();
          freeDraw.clear();
        }
      });
      this.myMap.addLayer(freeDraw);

      const fnToggleDrawing = function (isDrawing) {
        const elem = document.getElementById("_btnIsDrawing");
        if (isDrawing) {
          if (!elem.classList.contains("drawing")) {
            elem.classList.add("drawing");
          }
          freeDraw.mode(ALL);
          freeDraw.clear();
        } else {
          if (elem.classList.contains("drawing")) {
            elem.classList.remove("drawing");
          }
          freeDraw.mode(NONE);
        }
      };

      // Add the draw toggle button
      let drawToggleControl = L.control({ position: "topleft" });
      drawToggleControl.onAdd = function (map) {
        let div = L.DomUtil.create("div");
        // clean up this part
        div.innerHTML = ``;
        div.id = "_btnIsDrawing";

        div.onclick = function (evt) {
          me.isDrawing = !me.isDrawing;
          fnToggleDrawing(me.isDrawing);
        };

        div.setAttribute("class", "map-button mdi mdi-draw tool");

        return div;
      };
      drawToggleControl.addTo(this.myMap); // your map variable

      let staffIdControl = L.control({ position: "bottomright" });
      staffIdControl.onAdd = function (map) {
        let div = L.DomUtil.create("div");
        // clean up this part
        div.innerHTML = `Staff ID: ${me.selectedStaffId}`;
        div.id = "_divStaffId";

        div.onclick = function (evt) {
          me.selectedStaffId = "";
          div.innerHTML = `Staff ID: ${me.selectedStaffId}`;
        };

        div.setAttribute(
          "style",
          "border: 2px solid #15487c;border-radius: 5px;padding: 5px;font-weight: bold;background-color: white;"
        );

        return div;
      };
      staffIdControl.addTo(this.myMap); // your map variable
    },
    shouldAddCaseToList(status, priority) {
      if (this.mapViewModel.isUnassignedDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.UNASSIGNED && priority === 0) {
        return true;
      }

      if (this.mapViewModel.isUnassignedHighPriorityDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.UNASSIGNED && priority === 1) {
        return true;
      }

      if (this.mapViewModel.isNotReviewedDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.NOTREVIEWED && priority === 0) {
        return true;
      }

      if (this.mapViewModel.isNotReviewedHighPriorityDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.NOTREVIEWED && priority === 1) {
        return true;
      }

      if (this.mapViewModel.isConfirmedDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.CONFIRMED && priority === 0) {
        return true;
      }

      if (this.mapViewModel.isConfirmedHighPriorityDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.CONFIRMED && priority === 1) {
        return true;
      }

      // screeners
      if (this.mapViewModel.isScreenerUnassignedDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.SCREENER_UNASSIGNED && priority === 0) {
        return true;
      }

      if (this.mapViewModel.isScreenerNotReviewHighPriorityDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.SCREENER_UNASSIGNED_HIGH_PRIORITY && priority === 1) {
        return true;
      }

      if (this.mapViewModel.isScreenerNotReviewDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.SCREENER_NOT_REVIEWED && priority === 0) {
        return true;
      }

      if (this.mapViewModel.isScreenerNotReviewHighPriorityDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.SCREENER_NOT_REVIEWED_HIGH_PRIORITY && priority === 1) {
        return true;
      }

      if (this.mapViewModel.isScreenerConfirmedDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.SCREENER_CONFIRMED && priority === 0) {
        return true;
      }

      if (this.mapViewModel.isScreenerConfirmedHighPriorityDisplayed &&
        status === TASK_CONSTANTS.TASK_STATUS.SCREENER_CONFIRMED_HIGH_PRIORITY && priority === 1) {
        return true;
      }

      return false;
    },
    findPointsInRegionWithTypeCheck(cases, bounds) {
      const me = this;
      if (cases && cases.getLayers().length > 0) {
        cases.eachLayer((theCase) => {
          const props = theCase.feature.properties;
          // Check to see if the case should be added
          if (me.shouldAddCaseToList(props.assignStatus, props.priority)) {
            // Check that it's within the drawn region bounds...
            if (bounds.contains(latlng)) {
              const duid = theCase.dwellingId ? theCase.dwellingId : props.DUID;
              Vue.set(me.selectedRegionCases, duid, theCase);
            }
          }
        });
      }
    },
    findPointsInRegion(cases, bounds) {
      if (cases && cases.getLayers().length > 0) {
        cases.eachLayer((theCase) => {
          const latlng = (theCase.getLatLng) ? theCase.getLatLng() :
            L.latLng(theCase.feature.geometry.coordinates[1], theCase.feature.geometry.coordinates[0]);

          const props = theCase.feature.properties;

          if (bounds.contains(latlng)) {
            Vue.set(this.selectedRegionCases, props.DUID, theCase);
          }
        });
      }
    },
    onToggleMapFilter() {
      this.toggleFilter = !this.toggleFilter;
    },
    /**
     * Shows\hides layers on a map
     *
     * @param evt - show or hide the layers
     * @param layerNameId - layer name ID
     */
    onMapSettingsChanged(evt, layerNameId) {
      const bShowLayers = evt;
      let layers;
      switch (layerNameId) {
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.UNASSIGNED: // unassigned
          this.mapViewModel.isUnassignedDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.unassigned;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.NOT_REVIEWED: // not reviewed
          this.mapViewModel.isNotReviewDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.notReviewed;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.CONFIRMED: // confirmed
          this.mapViewModel.isConfirmedDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.confirmed;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.ASSIGNED: // assigned
          this.mapViewModel.isAssignedDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.assigned;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.UNASSIGNED_HIGH_PRIORITY: // unassigned - high priority
          this.mapViewModel.isUnassignedHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.unassignedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.NOT_REVIEWED_HIGH_PRIORITY: // not reviewed - high priority
          this.mapViewModel.isNotReviewHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.notReviewedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.CONFIRMED_HIGH_PRIORITY: // confirmed - high priority
          this.mapViewModel.isConfirmedHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.confirmedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.ASSIGNED_HIGH_PRIORITY: // assigned - high priority
          this.mapViewModel.isAssignedHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.assignedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_UNASSIGNED: // screen unassigned
          this.mapViewModel.isScreenerUnassignedDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerUnassigned;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_NOT_REVIEWED: // screen not reviewed
          this.mapViewModel.isScreenerNotReviewDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerNotReviewed;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_CONFIRMED: // screen confirmed
          this.mapViewModel.isScreenerConfirmedDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerConfirmed;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_ASSIGNED: // screen assigned
          this.mapViewModel.isScreenerAssignedDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerAssigned;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_UNASSIGNED_HIGH_PRIORITY: // screen unassigned - high priority
          this.mapViewModel.isScreenerUnassignedHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerUnassignedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_NOT_REVIEWED_HIGH_PRIORITY: // screen not reviewed - high priority
          this.mapViewModel.isScreenerNotReviewHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerNotReviewedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_CONFIRMED_HIGH_PRIORITY: // screen confirmed - high priority
          this.mapViewModel.isScreenerConfirmedHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerConfirmedHighPriority;
          break;
        case MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_ASSIGNED_HIGH_PRIORITY: // screen assigned - high priority
          this.mapViewModel.isScreenerAssignedHighPriorityDisplayed = bShowLayers;
          layers = this.mapFeatureMarkers.screenerAssignedHighPriority;
          break;
        default:
          // 0 or Interviewer Home
          this.mapViewModel.isStaffDisplayed = evt;
          layers = this.mapFeatureMarkers.staff;
          break;
      }

      if (layers) {
        if (bShowLayers) {
          this.myMap.addLayer(layers);
        } else {
          this.myMap.removeLayer(layers);
        }
      }
    },
    highlightStaffPolygon(staffId) {
      if(!staffId) {  // Unassigned was selected so clear highlighted polygons
        if(this.mapFeatureMarkers.assignedArea && this.mapFeatureMarkers.assignedArea.eachLayer) {
          this.mapFeatureMarkers.assignedArea.eachLayer((layer) => {
              layer.setStyle(MAP_CONSTANTS.POLYGON_STYLES.DEFAULT); // resets layer colors
          });
        }
      } else {  // Valid staff ID (not unassigned) so clear previously highlighted and highlight staff
        if(this.mapFeatureMarkers.assignedArea && this.mapFeatureMarkers.assignedArea.eachLayer) {
          this.mapFeatureMarkers.assignedArea.eachLayer((layer) => {
            if (layer.feature.id && layer.feature.id.includes("poly-" + staffId)) {
              layer.setStyle(MAP_CONSTANTS.POLYGON_STYLES.HIGHLIGHTED); // highlights selected.
              this.myMap.fitBounds(layer.getBounds(), {
                animate: true,
                padding: [5, 5],
              });
            } else {
              layer.setStyle(MAP_CONSTANTS.POLYGON_STYLES.DEFAULT); // resets layer colors
            }
          });
        }

        this.highlightStaffCasesInPolygon(staffId);
      }
    },
    /**
     * Set the opacity to 1 for markers assigned to selected staff ID. All other markers
     * will have opacity set to .75
     * @param {*} markers
     * @param {*} staffId
     */
    highlightStaffCasesInPolygon(staffId) {
      const me = this;  // ref to this inside forEach scope...
      this.ASSIGNED_TASK_LAYER_NAMES.forEach((layerName) => {
        if(me.mapFeatureMarkers[layerName] && me.mapFeatureMarkers[layerName].eachLayer) {
          me.mapFeatureMarkers[layerName].eachLayer((layer) => {
            if(layer.feature && layer.feature.properties && layer.setOpacity) {
              const props = layer.feature.properties;
              if(props.StaffId && props.StaffId === staffId) {
                layer.setOpacity(MAP_CONSTANTS.ASSIGNMENT_MAP_MARKER_OPAQUES.SHOW);
              } else {
                layer.setOpacity(MAP_CONSTANTS.ASSIGNMENT_MAP_MARKER_OPAQUES.BARELY_SHOW);
              }
            }
          });
        }
      });
    },
    openMultiplePopUp() {
      this.$store.commit(this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_SELECTED_CASE_IDS, {
        data: this.selectedRegionCases,
      });
    },
    onCaseClicked(dwellingId) {
      const layers = this.myMap._layers;
      let popupLayer;
      for (let key in layers) {
        const layer = layers[key];
        if (layer.feature && layer.feature.properties.DUID === dwellingId) {
          popupLayer = layer;
          break;
        }
      }

      if (popupLayer) {
        let statusWord = popupLayer.feature.properties.Status;
        if (popupLayer.feature.properties.Status === "NOTREVIEWED") {
          statusWord = "Not Reviewed";
        }

        let popupAddress = "";
        // looping through bottom row data to compare DUIDS to find address // this just supplies the address for the entire map
        for (let check of this.allStaffData) {
          if (popupLayer.feature.properties.DUID === check.dwellingId) {
            popupAddress = check.address.streetAddress + " " +
              check.address.placeName + "," +
              check.address.adminAreaCode + " " +
              check.address.postCode;
          }
        }

        const content = mapMarkerService.getAssignmentTaskPopupContent(statusWord, popupAddress, popupLayer.feature.properties);
        this.layerPopup.setContent(content);
        this.layerPopup.setLatLng(popupLayer.getLatLng());
        this.myMap.openPopup(this.layerPopup);
      }
    },
    // move to service!!!!!
    percent(val) {
      return Number(val * 100).toFixed(0) + "%";
    },
    onToggleScreensChanged() {
      this.mapViewModel.isUnassignedDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.UNASSIGNED);

      this.mapViewModel.isUnassignedHighPriorityDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.UNASSIGNED_HIGH_PRIORITY);

      this.mapViewModel.isNotReviewedDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.NOT_REVIEWED);

      this.mapViewModel.isNotReviewedHighPriorityDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.NOT_REVIEWED_HIGH_PRIORITY);

      this.mapViewModel.isConfirmedDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.CONFIRMED);

      this.mapViewModel.isConfirmedHighPriorityDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.CONFIRMED_HIGH_PRIORITY);

      this.mapViewModel.isAssignedDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.ASSIGNED);

      this.mapViewModel.isAssignedHighPriorityDisplayed = this.isShowRegular;
      this.onMapSettingsChanged(this.isShowRegular, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.ASSIGNED_HIGH_PRIORITY);

      this.mapViewModel.isScreenerUnassignedDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_UNASSIGNED);

      this.mapViewModel.isScreenerUnassignedHighPriorityDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_UNASSIGNED_HIGH_PRIORITY);

      this.mapViewModel.isScreenerNotReviewedDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_NOT_REVIEWED);

      this.mapViewModel.isScreenerNotReviewedHighPriorityDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_NOT_REVIEWED_HIGH_PRIORITY);

      this.mapViewModel.isScreenerConfirmedDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener,MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_CONFIRMED);

      this.mapViewModel.isScreenerConfirmedHighPriorityDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREENER_CONFIRMED_HIGH_PRIORITY);

      this.mapViewModel.isScreenerAssignedDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREEN_ASSIGNED);

      this.mapViewModel.isScreenerAssignedHighPriorityDisplayed = this.isShowScreener;
      this.onMapSettingsChanged(this.isShowScreener, MAP_CONSTANTS.CASE_ASSIGN_MARKER_TYPES.SCREEN_ASSIGNED_HIGH_PRIORITY);
    },
  },
};
</script>

<style scoped>
.map {
  height: 800px;
  /* height: 43vh; */
  /* height: 50vh; */
  /* margin: 10px 10px 10px 10px; */
  /* position: absolute; */
	position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 1px solid rgb(21 72 124);
}
.staff-id-container {
  border: 2px solid;
  border-radius: 5px;
  height: 200px;
  width: 200px;
}
.task-type-border {
  border: 1px solid;
  margin: 5px;
}
.task-type {
  margin: 5px;
}

.map-button {
  width: 32px;
  height: 32px;
  line-height: 30px;
  background-color: #fff9;
  color: #17677d;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border: 1px solid;
  margin-left: 11px;
  border-radius: 3px;
  font-size: 18px;
  border-radius: 50px;
}
.v-input--selection-controls {
    margin-top: 0px;
}

</style>
